import { render, staticRenderFns } from "./seamlessScroll.vue?vue&type=template&id=77125a41&scoped=true"
import script from "./seamlessScroll.vue?vue&type=script&lang=js"
export * from "./seamlessScroll.vue?vue&type=script&lang=js"
import style0 from "./seamlessScroll.vue?vue&type=style&index=0&id=77125a41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77125a41",
  null
  
)

export default component.exports